import { useCallback, useEffect, useState } from 'react';

export function useReportExpandState(resetKey) {
  const [expandedDirectCategories, setExpandedDirectCategories] = useState(new Set());
  const [expandedDepCategories, setExpandedDepCategories] = useState(new Set());

  const toggleDirectCategory = useCallback((id) => {
    setExpandedDirectCategories((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const toggleDepCategory = useCallback((id) => {
    setExpandedDepCategories((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  useEffect(() => {
    setExpandedDirectCategories((prev) => (prev.size === 0 ? prev : new Set()));
    setExpandedDepCategories((prev) => (prev.size === 0 ? prev : new Set()));
  }, [resetKey]);

  return {
    expandedDirectCategories,
    expandedDepCategories,
    toggleDirectCategory,
    toggleDepCategory,
  };
}
